import { useState, useEffect, useRef } from "react";

/**
 * Custom hook for managing dropdown state with outside click handling
 * 
 * @returns {Object} Dropdown state and handlers
 */
export function useDropdownState() {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return {
        isOpen,
        setIsOpen,
        dropdownRef,
    };
}
